<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12" v-if="api_key">
        <iframe allowtransparency="true" width="100%" height="100%" style="min-height: 84vh"
          :src="'https://connect.uxlove.studio/auth/' + api_key"></iframe>
        <!--        <iframe allowtransparency="true" width="100%" height="100%" style="min-height: 84vh" :src="'http://localhost:8081/auth/'+api_key"></iframe>-->
      </div>
      <div v-else>
        <router-link :to="{ name: 'SettingsApi' }">{{ $static('connect.create-api-key', 'Створіть api ключ')
          }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'Connect',
  components: {},
  data() {
    return {}
  },
  computed: {
    settings() {
      return this.$store.getters.settings
    },
    api_key() {
      return this.settings?.env?.API_KEY ? this.settings.env.API_KEY : undefined
    }
  },
  methods: {},
  mounted() { }
}
</script>

<style>
iframe {
  border: none;
}
</style>